// Auto-resize handshake for the embeddable tool surface (/embed/tools/*).
//
// The embed document posts its height to the parent frame; the host page's
// snippet listens for tqEmbedHeight messages and sizes the iframe to fit, so a
// growing QR result doesn't get clipped or leave a tall gap. No-op unless we
// are actually inside the embed surface (data-embed) and framed.

export function setupEmbedResize() {
  if (typeof document === "undefined") return
  const body = document.body
  if (!body || body.dataset.embed !== "true") return
  if (window.parent === window) return // not framed; nothing to talk to

  const postHeight = () => {
    const height = Math.ceil(document.documentElement.getBoundingClientRect().height)
    window.parent.postMessage({ tqEmbedHeight: height }, "*")
  }

  postHeight()
  // The widget grows when a QR result appears, so re-post on any layout change.
  if (typeof ResizeObserver === "function") {
    new ResizeObserver(postHeight).observe(body)
  } else {
    window.addEventListener("resize", postHeight)
  }
}
